// @noflow
import { HomeIcon, HubClockContainer, HubClockLongTimeSpan, HubClockShortTimeSpan } from './styles';

import generalIcons from '~/core/constants/icons/general-svg';
import { momentObj } from 'react-moment-proptypes';
import * as React from 'react';

const propTypes = {
    hubDateTime: momentObj.isRequired
};

const HubClock = ({ hubDateTime }) => (
    <HubClockContainer>
        <HomeIcon type={generalIcons.HOME} />
        <HubClockLongTimeSpan>{hubDateTime.format('llll')}</HubClockLongTimeSpan>
        <HubClockShortTimeSpan>{hubDateTime.format('LT')}</HubClockShortTimeSpan>
    </HubClockContainer>
);

HubClock.propTypes = propTypes;

export default HubClock;



// WEBPACK FOOTER //
// ./src/components/widgets/hub-clock/index.js